import { ActionIcon, Collapse, Group, Stack, Text } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { IconChevronDown, IconChevronUp } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import { Content, NoContentPlaceholder } from '@/core/components';

import { ValidationCard } from '@feature/validation/ValidationCard';
import { Validation } from '@feature/validation/ValidationTypes';

interface ValidationHistoryBoxProps {
  history: Validation[];
  defaultIsCollapsed?: boolean;
}

export function ValidationHistoryContent({ history, defaultIsCollapsed }: ValidationHistoryBoxProps) {
  const { t } = useTranslation();
  const [opened, { toggle }] = useDisclosure(!defaultIsCollapsed);
  if (history.length == 0) return null;

  return (
    <Content type="full">
      <Group gap="4px">
        <Text fw="500">{t('validation.history.title')}</Text>
        <ActionIcon
          onClick={toggle}
          variant="subtle"
          aria-label={t('validation.history.toggle')}
          aria-expanded={opened}
        >
          {!opened && (
            <IconChevronDown
              style={{ width: '70%', height: '70%' }}
              stroke={1.5}
            />
          )}
          {opened && (
            <IconChevronUp
              style={{ width: '70%', height: '70%' }}
              stroke={1.5}
            />
          )}
        </ActionIcon>
      </Group>
      <Collapse in={opened}>
        {history.length === 0 && <NoContentPlaceholder title={t('validation.history.empty')} />}
        <Stack>
          {history.map(item => (
            <ValidationCard
              key={item.id}
              validation={item}
            />
          ))}
        </Stack>
      </Collapse>
    </Content>
  );
}
